import { ActionTree } from 'vuex';
import { State } from '@/store/modules/campaign/state';
import { RootState } from '@/store/state';

export const actions: ActionTree<State, RootState> = {};
